<ngx-loading [show]="loading"></ngx-loading>
<div>
  <div bsModal #setDatesModal="bs-modal" class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-sm" role="document">
      <div class="modal-content extension-modal-custom">
        <div class="extension-header">
          <div class="extension-title">Set Extension Deadlines</div>
          <div class="cross" (click)="cancel()">
            <img src="assets/img/x.svg" alt="" />
          </div>
        </div>
        <div class="deadline-label">Deadline</div>
        <div class="extension-content">
          <div>
            <mat-tab-group
              class="small-tabs"
              [(selectedIndex)]="selectedTabIndex"
              (selectedIndexChange)="onTabChange([30, 60, 90][$event])">
              <mat-tab label="30 days"></mat-tab>
              <mat-tab label="60 days"></mat-tab>
              <mat-tab label="90 days"></mat-tab>
            </mat-tab-group>
          </div>

          <form [formGroup]="addDateForm">
            <div class="deadline-input-section">
              <div class="deadline-input-wrapper">
                <div class="input-container">
                  <app-datepicker-input
                    style="width: 19rem; margin-top: 2px"
                    *ngIf="!loading"
                    [validationStyle]="true"
                    [formControl]="addDateForm.get('violationActionRequiredDeadline')"
                    class="deadline-input">
                  </app-datepicker-input>
                  <small
                    class="error-message"
                    *ngIf="addDateForm.get('violationActionRequiredDeadline').hasError('dateInvalid')">
                    Please select a date later than today.
                  </small>
                </div>
              </div>
            </div>

            <div class="reason-section">
              <div class="reason-label">Reason</div>
              <div class="reason-input-wrapper">
                <div class="input-container">
                  <textarea class="reason-textarea" placeholder="Type here" formControlName="reason"></textarea>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div class="extension-actions">
          <button class="btn-cancel" (click)="cancel()">
            <div class="btn-text">Cancel</div>
          </button>
          <button [disabled]="!this.addDateForm.valid" class="btn-save btn btn-primary" (click)="save()">
            <div class="btn-text">Save</div>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
